import { useLayoutEffect, useRef, useState } from "react"

import { create as ckeditor_create } from "manager/ckeditor/ckeditor"
import "manager/ckeditor/ckeditor.css"

import noticeStyle from "./notice.module.css"
import { notice_save } from "./@@@/save"
import { notice_load } from "./@@@/load"
import { notice_remove } from "./@@@/remove"
import managerStyle from "manager/manager.module.css"


export default function Notice() {

    const isMounted = useRef(0)

    const [ckeditor, Set_ckeditor] = useState(null)
    const [noticeList, Set_noticeList] = useState([])

    const [noticeTitle, Set_noticeTitle] = useState('')

    window.EventManager["ckeditor"] = ckeditor

    useLayoutEffect(() => {
        if(isMounted.current === 0) {
            notice_load({
                Set_noticeList: Set_noticeList,
                isMounted: isMounted
            })
        }
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            content_load()
        }
        else if(isMounted.current === 2) {
            if(noticeList.length !== 0) {
                document.getElementById('notice_id').value = noticeList[0]['id']
                const content = noticeList[0]['content']
                ckeditor.setData(content)
            }
            else {
                document.getElementById('notice_id').value = ''
                Set_noticeTitle('')
                ckeditor.setData('')
            }
        }
    }, [noticeList])

    async function content_load() {
        let content = ''

        if(noticeList.length > 0) {
            const notice_id = noticeList[0]['id']
            const title = noticeList[0]['title']
            content = noticeList[0]['content']

            document.getElementById('notice_id').value = notice_id

            Set_noticeTitle(title)
        }

        ckeditor_create({
            content: content,
            Set_ckeditor: Set_ckeditor
        });

        isMounted.current++
    }

    return(
        <>
            <div
                className={noticeStyle['noticeWrap']}
            >
                <input type="hidden" id="notice_id"></input>

                <div
                    className="ckeditorContainer"
                    style={{
                        marginBottom: "5px"
                    }}
                >
                    <label className={managerStyle['label']}>제목</label>
                    <div
                        style={{
                            width: "100%",
                            height: "30px",
                            border: "1px solid #c9caca"
                        }}
                    >
                        <input
                            type="text"
                            style={{
                                width: "100%",
                                height: "100%",
                                boxSizing: "border-box",
                                outline: "none",
                                border: "none",
                                paddingInline: "5px"
                            }}
                            value={noticeTitle}
                            onChange={(e) => Set_noticeTitle(e.currentTarget.value)}
                        ></input>
                    </div>
                </div>

                <div
                    className="ckeditorContainer"
                    style={{
                        marginBottom: "5px"
                    }}
                >
                    <label className={managerStyle['label']}>내용</label>
                    <div id="ckeditor"></div>
                </div>

                <div>
                    <button
                        type="button"
                        className={`
                            ${managerStyle['button']}
                            ${managerStyle['primary']}
                        `}
                        onClick={() => notice_save({
                            ckeditor: ckeditor,
                            Set_noticeList: Set_noticeList,
                            noticeTitle: noticeTitle
                        })}
                    >저장</button>

                    <span style={{marginInline: "5px"}}></span>

                    {noticeList.length > 0 &&
                        <button
                            type="button"
                            className={`
                                ${managerStyle['button']}
                                ${managerStyle['danger']}
                            `}
                            onClick={() => notice_remove({
                                Set_noticeList: Set_noticeList
                            })}
                        >삭제</button>
                    }
                </div>
            </div>

            {/* <div className={noticeStyle['noticeList']}>
                {noticeList
                .map((value, index) => {
                    return(
                        <div
                            key={index}
                            className={noticeStyle['select']}
                        >
                            <div className={noticeStyle['title']}>{value['title']}</div>
                            <div
                                className={noticeStyle['content']}
                                dangerouslySetInnerHTML={{
                                    __html: value['content']
                                }}
                            ></div>
                        </div>
                    )
                })}
            </div> */}
        </>
    )
}